export const POMPEI_DEFAULT_MAP_LAYER_KEY = 'map.tiles_url'

export const POMPEI_MAP_LAYER_OPTIONS = Object.freeze([
    {
        key: 'map.drone_tiles_url',
        label: 'ORTOFOTO',
    },
    {
        key: POMPEI_DEFAULT_MAP_LAYER_KEY,
        label: 'PIANTA ARCHEOLOGICA',
    },
])

export const POMPEI_VALID_MAP_LAYER_KEYS = Object.freeze(
    POMPEI_MAP_LAYER_OPTIONS.map(option => option.key)
)

const POMPEI_MAP_LAYER_CONFIGS = Object.freeze({
    'map.drone_tiles_url': {
        maxNativeZoom: 21,
        maxNativeZoomSettingKey: 'map.drone_max_native_zoom',
        stackLayers: true,
        stackOrder: 'bottom-to-top',
    },
})

function getMapSettings(settings = null) {
    return settings ?? (typeof window !== 'undefined' ? window?.catalog?.settings : {}) ?? {}
}

function parseIntegerSetting(value) {
    const parsedValue = parseInt(value, 10)

    return Number.isFinite(parsedValue) ? parsedValue : null
}

export function isPompeiMapLayerKey(key) {
    return POMPEI_VALID_MAP_LAYER_KEYS.includes(key)
}

export function hasPompeiMapLayerSetting(key, settings = null) {
    return Boolean(getMapSettings(settings)?.[key])
}

export function getAvailablePompeiMapLayerOptions(settings = null) {
    const mapSettings = getMapSettings(settings)
    const availableOptions = POMPEI_MAP_LAYER_OPTIONS.filter(option =>
        hasPompeiMapLayerSetting(option.key, mapSettings)
    )

    if (availableOptions.length > 0) {
        return availableOptions
    }

    return POMPEI_MAP_LAYER_OPTIONS.filter(option => option.key === POMPEI_DEFAULT_MAP_LAYER_KEY)
}

export function resolvePompeiMapLayerKey(key, settings = null) {
    const mapSettings = getMapSettings(settings)

    if (isPompeiMapLayerKey(key) && hasPompeiMapLayerSetting(key, mapSettings)) {
        return key
    }

    if (hasPompeiMapLayerSetting(POMPEI_DEFAULT_MAP_LAYER_KEY, mapSettings)) {
        return POMPEI_DEFAULT_MAP_LAYER_KEY
    }

    return getAvailablePompeiMapLayerOptions(mapSettings)[0]?.key ?? POMPEI_DEFAULT_MAP_LAYER_KEY
}

export function getPompeiMapLayerConfig(key, settings = null) {
    const config = POMPEI_MAP_LAYER_CONFIGS[key]

    if (!config) {
        return {}
    }

    const mapSettings = getMapSettings(settings)
    const configuredMaxNativeZoom = parseIntegerSetting(mapSettings[config.maxNativeZoomSettingKey])

    return {
        maxNativeZoom: configuredMaxNativeZoom ?? config.maxNativeZoom,
        stackLayers: config.stackLayers ?? false,
        stackOrder: config.stackOrder,
    }
}